import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateRange } from '../medarbejdere-range-picker/medarbejdere-range-picker.component';

@Component({
    selector: 'app-medarbejdere-fravaer-picker',
    templateUrl: './medarbejdere-fravaer-picker.component.html',
    styleUrls: ['./medarbejdere-fravaer-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})

export class MedarbejdereFravaerPickerComponent {
    @Input() activeYear: number = new Date().getFullYear();

    constructor(public activeModal: NgbActiveModal) {}

    fravaerTypes = [
        'Ingen fravaer',
        'Ferie',
        'Barsel',
        'Skole',
        'Afspadsering'
    ];

    selectedType = this.fravaerTypes[0];
    dateRange: DateRange = { from: null, to: null };

    getOptionClass(type: string): string {
        switch (type) {
            case 'Ferie':
                return 'option-ferie';
            case 'Barsel':
                return 'option-barsel';
            case 'Skole':
                return 'option-skole';
            case 'Afspadsering':
                return 'option-afspadsering';
            default:
                return '';
        }
    }

    isValid(): boolean {
        if (!this.dateRange.from || !this.dateRange.to) {
            return false;
        }

        const from = new Date(this.dateRange.from);
        const to = new Date(this.dateRange.to);

        return from <= to;
    }

    getKodeFromType(): number {
        switch (this.selectedType) {
            case 'Ferie': return 1;
            case 'Barsel': return 2;
            case 'Skole': return 3;
            case 'Afspadsering': return 4;
            default: return 0;
        }
    }

    save() {
        if (!this.isValid()) {
            return;
        }

        const payload = {
            type: this.selectedType,
            kode: this.getKodeFromType(),
            fromDate: this.dateRange.from,
            toDate: this.dateRange.to
        };

        this.activeModal.close(payload);
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
